package com.ilussobsa.views

import com.ilussobsa.AnimationAction
import com.ilussobsa.AuctioneerView
import com.ilussobsa.auctioneer
import com.ilussobsa.utils.FullScreenAuction
import com.lightningkite.kiteui.Routable
import com.lightningkite.kiteui.identityHashCode
import com.lightningkite.kiteui.models.dp
import com.lightningkite.kiteui.navigation.Page
import com.lightningkite.kiteui.navigation.pageNavigator
import com.lightningkite.kiteui.reactive.*
import com.lightningkite.kiteui.views.*
import com.lightningkite.kiteui.views.direct.*
import com.lightningkite.reactive.context.*
import com.lightningkite.reactive.core.*
import com.lightningkite.reactive.extensions.*
import com.lightningkite.reactive.lensing.*
import com.lightningkite.readable.*
import kotlin.time.Duration.Companion.seconds
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.delay

@Routable("animation-test")
class AnimationTestingScreen: Page, FullScreenAuction, ControlsNavVisibility {
    override fun ReactiveContext.showNav(): Boolean = false
    override fun ViewWriter.render() = rowCollapsingToColumn(600.dp) {
        val auctionIsCountingDownSimulated = Signal(true)
        val rapidFireBids = Signal(true)

        lateinit var auctioneerView: AuctioneerView
        sizeConstraints(width = 500.dp, height = 450.dp) - auctioneer {
            auctioneerView = this
        }
        println("AnimationTestingScreen rendered with AuctioneerView instance ${auctioneerView.identityHashCode()}")

        val dontShowLoading = CoroutineScope(coroutineContext + object: StatusListener {
            override fun loading(readable: Reactive<*>) {}
        })

        dontShowLoading.reactiveSuspending {
            if (auctionIsCountingDownSimulated()) {
                delay(15.seconds)
                auctionIsCountingDownSimulated set false
            }
        }

        dontShowLoading.reactiveSuspending {
            if (auctionIsCountingDownSimulated()) return@reactiveSuspending
            while (rapidFireBids()) {
                auctioneerView.animationAction = AnimationAction.BIDDING_ACTION
                delay(500)
            }
        }

        expanding - col {
            row {
                AnimationAction.entries.forEach {
                    button {
                        text(it.action)
                        onClick {
                            auctioneerView.animationAction = it
                        }
                    }
                }
            }
            toggleButton {
                checked bind rapidFireBids
                text("Rapid Fire Bids")
            }
            toggleButton {
                checked bind auctionIsCountingDownSimulated
                text("Pause rapid fire for 15 seconds")
            }
            button {
                text("Refresh screen")
                onClick {
                    pageNavigator.navigate(AnimationTestingScreen())
                }
            }
        }
    }
}
